import { render, staticRenderFns } from "./Three60Environment.vue?vue&type=template&id=24a23dd7&scoped=true"
import script from "./Three60Environment.vue?vue&type=script&lang=js"
export * from "./Three60Environment.vue?vue&type=script&lang=js"
import style0 from "./Three60Environment.vue?vue&type=style&index=0&id=24a23dd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a23dd7",
  null
  
)

export default component.exports